<template>
  <div class="mandatory-checklist">
    <div v-if="mandatoryChecklist !== undefined && mandatoryChecklist.length > 0">
      <v-row v-for="item in mandatoryChecklist" :key="item.name" no-gutters>
        <v-col class="form-label mandatory-checklist-sub-header d-flex align-center">
          {{ item.title }}
        </v-col>
        <v-col cols="auto" class="d-flex align-center">
          <view-mandatory-checklist
            :title="item.title"
            :save-draft="saveDraft"
            :form-control-enabled="formControlEnabled && !archivedExcursionDetected"
          />
        </v-col>
      </v-row>
    </div>
    <div v-if="!mandatoryChecklist || mandatoryChecklist.length <= 0" class="excursion-waiting">
      <v-progress-circular
        :size="30"
        color="rgb(29, 175, 236)"
        class="loading-img"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';
import excursionStatus from '../lib/const/excursionStatus';
import ViewMandatoryChecklist from './ViewMandatoryChecklist';

export default {
  name: 'MandatoryChecklist',
  components: {
    ViewMandatoryChecklist
  },
  props: {
    saveDraft: {
      type: Function,
      default: () => {}
    },
    formControlEnabled: Boolean
  },
  data() {
    return {};
  },
  computed: {
    mandatoryChecklist() {
      const { mandatoryChecklist } = this.$store.state.common.excursionDc;
      const clonedMandatoryChecklist = JSON.parse(JSON.stringify(mandatoryChecklist));
      return clonedMandatoryChecklist.sort((a, b) => (a.title > b.title ? 1 : -1));
    },
    archivedExcursionDetected() {
      return excursionStatus.ARCHIVED === this.$store.state.common.excursionDc.status;
    }
  },
  async mounted() {
    const { mandatoryChecklist } = this.$store.state.common.excursionDc;
    this.$store.commit(types.COMMON_SET_MANDATORY_LOADING_COMPLETED, true);

    if (!mandatoryChecklist || mandatoryChecklist.length === 0) {
      const argHash = {
        stbApiAdapter: this.$app.stbApiAdapter,
        store: this.$store,
        queryParam: this.$route.query
      };
      await this.$store.dispatch('common/getMandatoryChecklist', argHash);
    } else {
      this.$store.commit(types.COMMON_SET_MANDATORY_LOADING_COMPLETED, false);
    }
  }
};
</script>
<style scoped>
.mandatory-checklist-sub-header {
  font-size: 14px;
}
</style>
